import React, { useContext } from "react";
import { StateContext, actions } from "../state/index";
import { applyCssFromJson, getStyleIdPrefixFromProgramName } from '../utils/css';
import { get } from 'lodash/object';

import "../styles.scss";

import RecipientPortal from "./RecipientPortal";
import ErrorBoundary from "./ErrorBoundary";
import SystemUnavailable from './library/SystemUnavailable';
import Modal from "./library/Modal";
import CheckBrowserCompatibility from './CheckBrowserCompatibility';
import { ERROR_TYPES, TOKEN_TYPES } from "../utils/enums";
import { isReturningFromOauth, replaceUrl, transformOauthQueryStringParameters } from "../utils/oauth";
import { transformConfigBasedOnAppState } from "../utils/configs";
import { useTranslation } from "react-i18next";
import { logUiError } from "../utils/logging";
import { decodeStateParam } from "../utils/encoding";

export const App = () => {
  const [applicationState, dispatch] = useContext(StateContext);
  const [t, i18n] = useTranslation(); // eslint-disable-line no-unused-vars
  const { modals, configuration } = applicationState;

  if (isReturningFromOauth()) {
    const queryParams = new URLSearchParams(window.location.search);
    const stateParam = queryParams.get('state');
    if(stateParam) {
      const decodedStateParam = decodeStateParam(stateParam);
      const { paywallUrl, applicationState } = decodedStateParam;
      const { selectedPaymentNetwork, tokens } = applicationState;
      const validatePayment = get(tokens, TOKEN_TYPES.VALIDATE_PAYMENT);
      dispatch(actions.selectedPaymentNetwork.setSelectedPaymentNetwork(selectedPaymentNetwork));
      dispatch(actions.tokens.setToken(TOKEN_TYPES.VALIDATE_PAYMENT, validatePayment));
      const transformedOauthParams = transformOauthQueryStringParameters();
      replaceUrl(`${paywallUrl}${transformedOauthParams}`);
    }
  }

  // TODO handle suspected firewall error...can probably handle by just checking for uncaught network errors when making the first http request to /validationAttempts
  const urlIsValid = /([A-z0-9]{8}-[A-z0-9]{4}-[A-z0-9]{4}-[A-z0-9]{4}-[A-z0-9]{12})/.test(window.location.href);

  // TODO why are we checking for modal.length
  if (!urlIsValid && !modals.length) {
    // TODO log malformed url to loggly so we can figure out how these errors are most likely happening
    const errorType = ERROR_TYPES.UI_ERRORS.MALFORMED_PAYWALL_URL;

    dispatch(actions.modals.showUiErrorModal(configuration, {
      errorType,
      contentProps: {
        showFaqLink: false
      }
    }));

    const additionalDataForLogs = {url: window.location.href};
    logUiError(errorType, applicationState, additionalDataForLogs);
  }

  const selectedLanguage = (i18n.languages && i18n.languages[0]) || 'en-US';
  const transformedAppState = {
    ...transformConfigBasedOnAppState({...applicationState, selectedLanguage}),
    selectedLanguage,
  };
  const transformedCss = get(transformedAppState, 'configuration.css');
  if(transformedCss){
    applyCssFromJson(transformedCss, getStyleIdPrefixFromProgramName(get(transformedAppState, 'configuration.programName')));
  }

  const systemUnavailableConfig = transformedAppState.configuration.systemUnavailable;

  console.log('transformed app state', transformedAppState)

  return (
    <StateContext.Provider value={[transformedAppState, dispatch]}>
      {
        systemUnavailableConfig.enabled ?
          <SystemUnavailable {...systemUnavailableConfig} /> :
          <div style={{ width: "100%", height: "100%"}}>
            <ErrorBoundary>
              <CheckBrowserCompatibility/>
              <Modal />
              {urlIsValid && <RecipientPortal />}
            </ErrorBoundary>
          </div>
      }
    </StateContext.Provider>
  );
};

export default App;
